define("tmds/geometry/Line", [
	"jquery",
	"./Extent",
	"./Geometry",
	"./Point",
	"./mathUtils",
	"../validator"
], function($, Extent, Geometry, Point, mathUtils, validator) {
	"use strict";
	
	/**
	 * check if the input geometry intersects with the line
	 * @param geom {tmds.geometry.Point} | {tmds.geometry.Line} | {tmds.geometry.Extent} 
	 * @return {Boolean}
	 */
	function intersects(geom) {
		if (!geom) {
			return false;
		}
			
		switch(geom.type) {
			case "Point":
				return mathUtils.lineContainsPoint(this, geom);
			case "Line":
				return mathUtils.lineIntersectsLine(this, geom);
			case "Extent":
				return geom.intersects(this);
		}
	}
	
	/**
	 * get the extent that wraps the line geometry
	 * @return {Object} in JSON format of tmds.geometry.Extent
	 */
	function toExtent() {
		return new Extent({
			xmin: Math.min(this.x1, this.x2),
			ymin: Math.min(this.y1, this.y2),
			xmax: Math.max(this.x1, this.x2),
			ymax: Math.max(this.y1, this.y2)
		});
	}
	
	/**
	 * return the line segment in JSON object format
	 * @return {Object} line representation in JSON object
	 */
	function toJson() {
		return {
			x1: this.x1,
			y1: this.y1,
			x2: this.x2,
			y2: this.y2,
			type: this.type
		};
	}
	
	/**
	 * construct a new line
	 * @param options {Object} option object with below structure
	 * 		{
	 * 			x1: 200,
	 * 			y1: 100,
	 * 			x2: 300,
	 * 			y2: 400 
	 * 		}
	 * @note all option members are optional
	 */
	var Line = function(options) {
		this.x1 = 0;
		this.y1 = 0;
		this.x2 = 0;
		this.y2 = 0;
		
		if (options != undefined) {			
			if(validator.isDataObject(options)) {				
				['x1', 'y1', 'x2', 'y2'].forEach(function(prop) {					
					if (options[prop] != undefined) {						
						if(!validator.isNumber(options[prop])) {
							throw new Error('Invalid ' + prop + ' value - ' + options[prop] + ' passed');
						}
						
						this[prop] = options[prop];
					}
				}, this);
			}
			else {
			 	throw new Error('Invalid options values - ' + options + ' passed');
			}
		}
	};
	
	Line.prototype = $.extend(Object.create(Geometry.prototype), {
		declaredClass: "tmds.geometry.Line",
		type: "Line",
		'intersects' : intersects,
		'toExtent' : toExtent,
		'toJson' : toJson
	});
	
	return Line;
});